import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Pricing from "./views/Pricing.vue";
import About from "./views/About.vue";
const CaseStudies = () => import("./views/CaseStudies.vue");
import Faq from "./views/Faq.vue";
import Contact from "./views/Contact.vue";
import Guarantee from "./views/Guarantee.vue";
// import Secondary from "./views/Secondary.vue";
import HowItWorks from "./views/HowItWorks.vue";
import Technologies from "./views/Technologies.vue";
import ProjectPaymentMicro from "./views/ProjectPaymentMicro.vue";
import ProjectPaymentUpgrade from "./views/ProjectPaymentUpgrade.vue";
import projectPaymentRepair from "./views/ProjectPaymentRepair.vue";
import ProjectPaymentCustom from "./views/ProjectPaymentCustom.vue";
import ProjectPaymentProPhase from "./views/ProjectPaymentProPhase.vue";
import ProjectPaymentSuccess from "./views/Success.vue";
// import Login from "./views/Login.vue";
// import Signup from "./views/Signup.vue";
import Articles from "./views/Articles.vue";
import ArticleDetail from "./views/ArticleDetail.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    // {
    //   path: "/secondary",
    //   name: "secondary",
    //   component: Secondary
    // },
    {
      path: "/how-it-works",
      name: "howItWorks",
      component: HowItWorks,
    },
    {
      path: "/about",
      name: "about",
      component: About,
    },
    {
      path: "/case-studies",
      name: "caseStudies",
      component: CaseStudies,
    },
    {
      path: "/pricing",
      name: "pricing",
      component: Pricing,
    },
    {
      path: "/payments/success",
      name: "projectPaymentSuccess",
      component: ProjectPaymentSuccess,
    },
    {
      path: "/payments/micro",
      name: "projectPaymentMicro",
      component: ProjectPaymentMicro,
    },
    {
      path: "/payments/repair",
      name: "projectPaymentRepair",
      component: projectPaymentRepair,
    },
    {
      path: "/payments/web-app-upgrade",
      name: "projectPaymentUpgrade",
      component: ProjectPaymentUpgrade,
    },
    {
      path: "/payments/next-phase-of-pro-project",
      name: "projectPaymentProPhase",
      component: ProjectPaymentProPhase,
    },
    {
      path: "/payments/web-app-next-phase",
      name: "ProjectPaymentCustom",
      component: ProjectPaymentCustom,
    },
    {
      path: "/technologies",
      name: "technologies",
      component: Technologies,
    },
    {
      path: "/faq",
      name: "faq",
      component: Faq,
    },
    {
      path: "/guarantee",
      name: "guarantee",
      component: Guarantee,
    },
    {
      path: "/contact",
      name: "contact",
      component: Contact,
    },
    // {
    //   path: "/articles/",
    //   name: "articles",
    //   component: Articles
    // },
    {
      path: "/articles",
      component: Articles,
      children: [
        {
          path: ":articleId",
          component: ArticleDetail,
          props: true,
        },
      ],
    },
  ],
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
